class CartComplementary extends HTMLElement {
    static selectors = {
      btnAdd: '[data-cart-add]',
    };
    btnAdd;
  
    constructor(){
      super();
      this.init();
    }
  
    init = () => {
      this.btnAdd = this.querySelector(CartComplementary.selectors.btnAdd);
  
      if(this.btnAdd)
        this.btnAdd.addEventListener('click', (e) => this.add(e));
    }

    add = () => {
      Utils.addTocart({
        form: this.querySelector('form')
      });
    }
  }
  if (!window.customElements.get("cart-complementary")) {
    window.customElements.define("cart-complementary", CartComplementary);
  }
  